import KendoEditor from './KendoEditor'
import KendoEditorTool from './KendoEditorTool'
import KendoEditorInstaller from './kendo-editor-installer'

export {
    KendoEditor, KendoEditor as Editor, KendoEditorTool, KendoEditorTool as EditorTool, KendoEditorInstaller, KendoEditorInstaller as EditorInstaller
}


// WEBPACK FOOTER //
// ./packages/kendo-editor-vue-wrapper/src/index.js